import react from 'react'
import {NavBar, Icon} from 'zarm'

export default function BaseLayout(props) {
  return (
    <div>
      {/* <NavBar
        left={<Icon type="arrow-left" theme="primary" onClick={() => window.history.back()} />}
        title="这是标题"
      /> */}
      <div>{props.children}</div>
    </div>
  )
}
